import type React from 'react';
import TooltipV2 from 'app/shared/modules/TooltipV2';
import { getPriceDropBadgeStyles, priceDropBadgeWrapperStyles } from './PriceDropBadge.styles';
import ArrowPriceDropTeal from 'images/icons/arrow-price-drop-teal.svg';

interface PriceDropBadgeProps {
  text?: string;
  variant?: 'hdp' | 'srp';
  showTooltip?: boolean;
  tooltipContent?: string;
}

const PriceDropBadge: React.FC<PriceDropBadgeProps> = ({
  text,
  variant = 'hdp',
  showTooltip = false,
  tooltipContent,
}) => {
  const badgeContent = (
    <span className={getPriceDropBadgeStyles(variant)} tabIndex={showTooltip ? 0 : undefined}>
      {variant === 'hdp' ? <img src={ArrowPriceDropTeal} alt="Price drop" /> : text}
    </span>
  );

  if (!showTooltip || !tooltipContent) {
    return <div className={priceDropBadgeWrapperStyles}>{badgeContent}</div>;
  }

  return (
    <div className={priceDropBadgeWrapperStyles}>
      <TooltipV2
        content={tooltipContent}
        position="below"
        size="auto"
        positionStrategy="trigger-relative"
        data-testid="price-drop-badge-tooltip"
      >
        {badgeContent}
      </TooltipV2>
    </div>
  );
};

export default PriceDropBadge;
